import store from '@/store';
import { server, domRoot } from './SERVER_ADDR';
export const SERVER_ADDR = server;
export const AJAX_REQ_ADDR = `${SERVER_ADDR}/online/ajax`;
export const AJAX_FILE_REQ_ADDR = `${SERVER_ADDR}/online/ajax-file`;
export const PDF_VIEWER_ADDRESS = `${domRoot}/pdf/viewer.html`;
export const DEFAULT_REQUEST_URL = '/online/ajax';
export const DEFAULT_FILE_REQUEST_URL = '/online/ajax-file';
export const SESSIONLESS_CONTROLLER = '/sessionless';

/**
 * Composes a request configuration object for axios
 * @param {object} reqData data 
 * @param {string} reqAction action  
 * @param {string} reqUrl /CONTROLLER/ACTION
 */
export function getRequestConfig (reqData, reqAction, reqUrl=DEFAULT_REQUEST_URL, reqMethod='post') {
  const data = {data: reqData, action: reqAction};
  let csrf = store.getters['login/getCsrf'];
  return {
    method: reqMethod,
    url: SERVER_ADDR+reqUrl,
    data: csrf ? { ...data,[csrf.param] : csrf.token } : data,
//    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}, 
    headers: {'Content-Type': 'application/json; charset=UTF-8'}, 
    withCredentials: true,
  };
}
export function getBinaryFileRequestConfig(reqData, reqAction) {
  const data = {data: reqData, action: reqAction};
  return {
    method: 'post',
    url: AJAX_REQ_ADDR,
    data: data,
    resposneType: 'arraybuffer',
    headers: {'Content-Type': 'application/json; charset=UTF-8'}, 
//    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': '*/*'}, 
    withCredentials: true,
  };

}

export function getPdfRequestConfig(reqData, reqAction, reqUrl=DEFAULT_REQUEST_URL, reqMethod='post') {
  const data = {data: reqData, action: reqAction};
  let csrf = store.getters['login/getCsrf'];
  return {
    method: reqMethod,
    url: SERVER_ADDR+reqUrl,
    data: csrf ? { ...data,[csrf.param] : csrf.token } : data,
    resposneType: 'json',
//    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': '*/*'}, 
    headers: {'Content-Type': 'application/json; charset=UTF-8'}, 
    withCredentials: true,
  };
}

export function getBlobRequestConfig(reqData, reqAction, reqUrl=DEFAULT_REQUEST_URL, reqMethod='post') {
  let csrf = store.getters['login/getCsrf'];
  const data = {data: reqData, action: reqAction};
  return {
    method: reqMethod,
    url: SERVER_ADDR+reqUrl,
    data: csrf ? { ...data,[csrf.param] : csrf.token } : data,
    resposneType: 'blob',
//    headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': '*/*'}, 
    headers: {'Content-Type': 'application/json; charset=UTF-8'}, 
    withCredentials: true,
  };
}

export function getFileUploadRequestConfig(formData, reqAction, reqUrl=DEFAULT_FILE_REQUEST_URL, reqMethod='post') {
  // formData.set('action-field', reqAction);
  formData['action-field'] = reqAction;
  return {
    method: reqMethod,
    url: SERVER_ADDR+reqUrl,
    data: formData,
    headers: {'Content-Type': 'multipart/form-data'}, 
    withCredentials: true,
  };
}
export function getFileDownloadRequestConfig(data, reqAction) {
  return {...getRequestConfig(data,reqAction), responseType: 'blob'};
}

/* simulate single grab event config */
export function getFullPageExtractionRequestConfig(pdfId, pageNumber, pageWidth, pageHeight, pageRotation) {
  return {
    pdfId: pdfId,
    source: {
      selections: [
        {
          selection: {
            top: 0,
            left: 0,
            right: pageWidth,
            bottom: pageHeight,
            width: pageWidth,
            height: pageHeight,
            x: 0,
            y: 0,
          },
          intersections: [
            {
              pageNumber: pageNumber,
              rectangle: {
                top: 0,
                left: 0,
                right: pageWidth,
                bottom: pageHeight,
                width: pageWidth,
                height: pageHeight,
              }
            }
          ],
        }
      ],
      rotation: pageRotation,
      referencedPages: [
        {
          rectangle: {
            top: 0,
            left: 0,
            width: pageWidth,
            height: pageHeight,
          },
          pageNumber: pageNumber,
        }
      ]
    },
    destination: {
      width: pageWidth,
      height: pageHeight,
    }
  };
}

